// extracted by mini-css-extract-plugin
module.exports = {"modalContainer":"ChatModal_modalContainer__3YC4f","title":"ChatModal_title__mGaS5","modalBody":"ChatModal_modalBody__1tLOn"};